/* src/app/views/template/components/templates/print/print-templates-container/print-templates-container.component.scss */
/*# sourceMappingURL=print-templates-container.component.css.map */
